import { ChevronRightIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import { Duration } from "luxon";
import React, { useEffect, useState } from "react";

import { TruncateWithTooltip } from "@components/TruncateWithTooltip";
import { getColorForGoal } from "@pages/VideoSessionsV2/components/MediaTimeline/helper";
import { useVideoSessionData } from "@providers/VideoSessionProviderV2";

interface OtherMomentCardProps {
  onClick: (startTime: number, endTime: number, momentId: string) => void;
  expandAll?: boolean;
}

export const OtherMomentCard: React.FC<OtherMomentCardProps> = ({ onClick, expandAll }) => {
  const [isExpanded, setIsExpanded] = useState(expandAll || false);
  const { mediaClassificationsData: momentsData, activeMomentId, activeMomentGoalId } = useVideoSessionData();

  useEffect(() => {
    setIsExpanded(expandAll || false);
  }, [expandAll]);

  useEffect(() => {
    if (activeMomentGoalId === "crying-and-screaming") {
      setIsExpanded(true);
    }
  }, [activeMomentGoalId, activeMomentId]);
  const handleMomentClick = (startTime: number, endTime: number, id: string) => {
    onClick(startTime, endTime, id);
  };
  const momentLabel = "Crying and Screaming";

  return (
    <div className="bg-white border border-limestone-200 rounded-2xl shadow-xs hover:shadow-md transition-shadow duration-200 overflow-hidden">
      <div className="flex items-center justify-between p-3 cursor-pointer" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <div className="w-1 h-6 rounded-full shrink-0" style={{ backgroundColor: getColorForGoal(momentLabel) }} />
          <ChevronRightIcon
            className={clsx(
              "w-4 h-4 text-limestone-600 transition-transform duration-200 shrink-0",
              isExpanded && "rotate-90",
            )}
          />
          <TruncateWithTooltip>
            <h4 className="text-sm font-medium text-limestone-900 flex-1">{momentLabel}</h4>
          </TruncateWithTooltip>
          <span className="px-2 py-0.5 text-xs font-medium text-limestone-600 bg-limestone-100 rounded-full shrink-0">
            {momentsData.length}
          </span>
        </div>
      </div>
      <div
        className={clsx(
          "space-y-1 overflow-y-auto transition-all duration-300",
          isExpanded ? "max-h-[800px]" : "max-h-0",
        )}
      >
        {momentsData.map((moment) => {
          const isActive = moment.id === activeMomentId;
          return (
            <div
              data-moment-id={moment.id}
              key={moment.id}
              onClick={() => handleMomentClick(moment.startTime, moment.endTime, moment.id)}
              className={clsx(
                "group flex items-center justify-between pl-4 pr-1 h-8  cursor-pointer transition-all duration-200 hover:bg-limestone-50 rounded-md",
                isActive && "bg-limestone-100 hover:bg-limestone-100",
              )}
            >
              <span className={clsx("text-sm font-mono text-green-900 pl-4", isActive ? "font-semibold" : "font-thin")}>
                {Duration.fromObject({ seconds: moment.startTime }).toFormat("hh:mm:ss")} -{" "}
                {Duration.fromObject({ seconds: moment.endTime }).toFormat("hh:mm:ss")}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
